export const workspaceQueryKeys = {
  currencies: ['currencies'] as const,
  timezones: ['timezones'] as const,
  headquarters: ['headquarters'] as const,
  countries: ['countries'] as const,
  holidays: (headquarter: string, year: number) => ['holidays', headquarter, year] as const,
  workspaces: ['workspaces'] as const,
  workspaceList: () => [...workspaceQueryKeys.workspaces, 'list'] as const,
  workspacesByIds: (ids: string[]) => [...workspaceQueryKeys.workspaces, 'by-ids', ids] as const,
};

export const clientQueryKeys = {
  clients: ['clients'] as const,
  clientList: () => [...clientQueryKeys.clients, 'list'] as const,
  clientsByIds: (ids: string[]) => [...clientQueryKeys.clients, 'by-ids', ids] as const,
};

export const searchQueryKeys = {
  searches: ['searches'] as const,
  searchesByIds: (ids: string[]) => [...searchQueryKeys.searches, 'by-ids', ids] as const,
};
